import { newE2EPage } from '@stencil/core/testing';

describe('jackery-tag', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-tag></jackery-tag>');

    const element = await page.find('jackery-tag');
    expect(element).toHaveClass('hydrated');
  });
});
